import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Grid, Divider, TextField, Button, Switch, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { Autorenew, Visibility, Search, CheckCircleOutline, HighlightOff } from '@material-ui/icons'
import { API, CURRENCY } from '@const'
import MemberDetailDialog from '@dialogs/member-detail-dialog'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import * as utils from '@utils'
import { PfSubPfSelect, CompleteDecimal } from '@select'
import { Table } from 'antd'

const COMPONENT_GROUP = 'member_list'

class MemberListPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'MemberListPage')
        }
        this.handleTableChange = this.handleTableChange.bind(this)
    }

    state = {
        searchType: 'platform',
        account: '',
        totalRemainMoney: 0,
        currency: CURRENCY.DEFAULT_CURRENCY,
        list: [],
        dataLength: 0,
        loading: false,
        currentPage: 1,
        pageLimit: 10,
        total: 0,
        pageSizeOptions: ['10','30','50','100'],
        sort_field: '',
        sort_order: ''
    }

    columns = [
        {
            title: utils.t('pf_account', 'MemberListPage'),
            dataIndex: 'pf_account',
            align: 'center',
        },
        {
            title: utils.t('origin_account', 'MemberListPage'),
            dataIndex: 'origin_account',
            align: 'center',
        },
        {
            title: utils.t('name', 'MemberListPage'),
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: utils.t('pf_sub_pf_id', 'MemberListPage'),
            dataIndex: 'pf_sub_pf_id',
            align: 'center',
            render: (text) => {
                return text ? utils.GeneratePfSubPfName(text) : ''
            },
        },
        {
            title: utils.t('money_lock', 'MemberListPage'),
            dataIndex: 'money_lock',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('money_free', 'MemberListPage'),
            dataIndex: 'money_free',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
                
            },
            sorter: true
        },
        {
            title: utils.t('last_login_at', 'MemberListPage'),
            dataIndex: 'last_login_at',
            align: 'center',
            render: (text) => {
                return utils.unixToDateTime(text)
            },
            sorter: true
        },
        {
            title: utils.t('last_login_ip', 'MemberListPage'),
            dataIndex: 'last_login_ip',
            align: 'center',
            sorter: true
        },
        {
            title: '',
            dataIndex: 'detail',
            align: 'center',
            render: (text, record) => {
                return (
                    <Button
                        style={{ minWidth: '93px' }}
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.detailDialog.OpenDialog({ pf_account: record.pf_account })
                        }}>
                        <Visibility className={this.props.classes.rightIcon} />
                        {this.t('detail')}
                    </Button>
                )
            },
        },
    ]

    componentDidMount() {
        this.updateTableColumns()
    }

    updateTableColumns() {
        if (utils.checkValid(COMPONENT_GROUP + '.active')) {
            this.columns.splice(this.columns.length - 1, 0, {
                title: utils.t('is_active', 'MemberListPage'),
                dataIndex: 'is_active',
                align: 'center',
                render: (text, record) => {
                    const { isAdmin } = this.props.auth
                    return isAdmin ? (
                        <Switch
                            checked={text}
                            onChange={(event) => {
                                this.confirmDialog.OpenDialog({
                                    type: 'info',
                                    msg: this.t('confirmSwitchMsg'),
                                    confirmParams: { checked: event.target.checked },
                                    confirm: (params) => {
                                        utils.apiRequest(
                                            'post',
                                            params.checked ? API.PLAYER_UNBLOCK : API.PLAYER_BLOCK,
                                            params.checked
                                                ? {
                                                    pf_account: record.pf_account,
                                                }
                                                : {
                                                    pf_account: record.pf_account,
                                                    reason: 'block by system',
                                                },
                                            (_data) => {
                                                this.confirmDialog.closeDialog()
                                                this.handlePageChange()
                                            },
                                            (_error) => {
                                                this.setState({loading: false})
                                            }

                                        )
                                    },
                                })
                            }}
                            value="Status"
                            color="primary"
                            inputProps={{ 'aria-label': 'Status' }}
                        />) : (
                            text ? (
                                <CheckCircleOutline className={this.props.classes.checkCircle} />
                            ) : (
                                <HighlightOff className={this.props.classes.highlightOff} />
                            )
                        )
                },
            })
        }
    }

    async queryData() {
        if (this.state.loading) { return }
        this.setState({
            loading: true
        })
        const queryParams = {}
        if (this.state.searchType === 'platform') {
            queryParams['pf_id'] = this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : ''
            queryParams['pf_sub_pf_id'] = this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : ''
        } else if (this.state.searchType === 'pfAccount') {
            queryParams['pf_account'] = this.state.account
        } else if (this.state.searchType === 'originAccount') {
            queryParams['origin_account'] = this.state.account
        } else if (this.state.searchType === 'moneyIsLock') {
            queryParams['is_money_lock'] = true
        }
        queryParams.page = this.state.currentPage
        queryParams.limit = this.state.pageLimit

        if (this.state.sort_field !== '' && this.state.sort_order !== '') {
            const sortParams = {
                "ascend": 'ASC',
                "descend": 'DESC'
            }
            queryParams.sort_field = this.state.sort_field
            queryParams.sort_order = sortParams[this.state.sort_order]
        }

        try {
            const response = await this.handleInquire(queryParams)
            const { data, page } = response

            const list = this.handleDataArrange(data)
            this.setState({
                list,
                dataLength: page.count,
                loading: false
            })
            
        } catch(error) {
            this.setState({
                list: [],
                dataLength: 0,
                loading: false
            })
        }
    }
    /** api */
    handleInquire(params) {
        return new Promise((resolve, reject) =>
            utils.apiRequest(
                'get',
                API.PLAYER_LIST,
                params,
                (data) => {
                    resolve(data)
                },
                (err) => {
                    reject(err)
                },
                true
            )
        )
    }

    /** 前端自產會員狀態 / 轉換幣值 */
    handleDataArrange(data) {
        data.forEach((item, index)=>{
            item['is_active'] = !item['is_block']
            item['money_free'] *= utils.getCurrencyRate(item['currency'])
            item['money_lock'] *= utils.getCurrencyRate(item['currency'])
            item['id'] = index
        })
        return data
    }

    /** submit */
    handleSearch() {
        this.setState({
            currentPage: 1
        }, () => {
            this.queryData()
        })
        
    }
    /** change page / limit */
    handlePageChange(page, limit) {
        const nextPage = page || this.state.currentPage
        const nextLimit = limit || this.state.pageLimit
        this.setState({
            currentPage: nextPage,
            pageLimit: nextLimit
        }, () => {
            this.queryData()
        })
    }

    handleTableChange(pagination, _filters, sorter) {
        const sort = (field, order) => {
            this.setState({
                sort_field: field,
                sort_order: order,
                pageLimit: pagination.pageSize
            })
        }
        sorter.order ? sort(sorter.field, sorter.order) : sort('', '')
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={7} className={this.props.classes.alignCenter}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) =>
                                this.setState({
                                    searchType: event.target.value,
                                })
                            }>
                            <MenuItem value="platform">{this.t('platform')}</MenuItem>
                            <MenuItem value="originAccount">{this.t('originAccount')}</MenuItem>
                            <MenuItem value="pfAccount">{this.t('pfAccount')}</MenuItem>
                            <MenuItem value="moneyIsLock">{this.t('moneyIsLock')}</MenuItem>
                        </Select>
                    </FormControl>
                    {this.state.searchType === 'platform' && (
                        <PfSubPfSelect
                            options={{
                                hideCurrency: true,
                                hideAllPlatform: true,
                            }}
                            onRef={(ref) => (this.pfSelect = ref)}></PfSubPfSelect>
                    )}
                    {(this.state.searchType === 'originAccount' || this.state.searchType === 'pfAccount') && (
                        <TextField
                            label={this.t('account')}
                            placeholder={this.t('enterAccountEntirely')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.account}
                            onChange={(event) =>
                                this.setState({
                                    account: event.target.value,
                                })
                            }
                            className={this.props.classes.textField}
                        />
                    )}
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.handleSearch()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                    <Grid item>
                        <CompleteDecimal />
                    </Grid>
                </Grid>
                {false && utils.checkValid(COMPONENT_GROUP + '.all_members_money') && (
                    <React.Fragment>
                        <Grid item xs={1} style={{ borderLeft: 'solid 1px'}} />
                        <Grid item xs={2}>
                            <TextField
                                label={this.t('totalRemainMoney')}
                                value={this.state.totalRemainMoney}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                className={this.props.classes.textField}
                                inputProps={{ readOnly: true, style: { textAlign: 'right' } }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2} className={this.props.classes.alignCenter}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={this.props.classes.button}
                                onClick={() => {
                                    utils.apiRequest('get', API.PLAYER_ALL_PLAYERS_MONEY, {}, (data) => {
                                        this.setState({
                                            totalRemainMoney: utils.currencyFormatter(data.money),
                                        })
                                    })
                                }}>
                                <Autorenew className={this.props.classes.rightIcon} />
                                {this.t('refresh')}
                            </Button>
                        </Grid>
                    </React.Fragment>
                )}
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        className="member-list-page"
                        size="small"
                        loading={this.state.loading}
                        columns={this.columns}
                        dataSource={this.state.list}
                        bordered
                        rowKey="id"
                        locale={{
                            emptyText: utils.t('noRecordsToDisplay', 'Table')
                        }}
                        pagination={{
                            current: this.state.currentPage,
                            pageSize: this.state.pageLimit,
                            total: this.state.dataLength,
                            showTotal: () => ``,
                            onChange: (nextPage, currentPageSize) => {
                                this.handlePageChange(nextPage, currentPageSize)
                            },
                            onShowSizeChange: (currentPage, nextSize) => {
                                this.handlePageChange(1, nextSize)
                            },
                            showSizeChanger: true, // 允许改变每页显示的条数
                            pageSizeOptions: this.state.pageSizeOptions, // 每页显示的条数选项
                        }}
                        onChange={this.handleTableChange} // 排序 篩選 資料變更 都會觸發這裡 目前用來 call 排序 api
                    />
                    <MemberDetailDialog onRef={(ref) => (this.detailDialog = ref)} />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '210px',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        checkCircle: {
            color: '#36B37E',
        },
        highlightOff: {
            color: '#FF5630',
        },
    }
}

MemberListPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(MemberListPage)
